import styles from './GridBackdrop.module.css';

// 製図グリッド背景（DESIGN §8.1）。装飾レイヤー。親要素を position: relative に。
// 「製図台の上」の空気を出したい箇所（Hero / 反転帯 / レポート表紙など）に薄く敷く。
type Props = {
  variant?: 'dots' | 'lines';
  /** 端をフェードさせる（中央寄りに視線を集める）。 */
  fade?: boolean;
  className?: string;
};

export default function GridBackdrop({ variant = 'dots', fade = false, className }: Props) {
  const cls = [
    styles.backdrop,
    variant === 'lines' ? 'bg-grid-lines' : 'bg-grid-dots',
    fade && styles.fade,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <div aria-hidden="true" className={cls} />;
}
